module.exports = __webpack_public_path__ + "media/all_mix_clip.1d65adaa.mp4";